import FormSelectPage from "@/pages/FormSelectPage";

export default {
    path: '/client-signup',
    name: 'client-signup',
    component: FormSelectPage
}